export function Accordion(){

  generalAccordion();
  window.addEventListener('resize', generalAccordion);


  function generalAccordion(){
    // Get all accordion items
    const accordionItems = document.querySelectorAll('.accordion .js-accordion-item');

    // Add click event listener to each accordion header
    accordionItems.forEach(item => {
      const header = item.querySelector('.accordion .js-accordion-item__header');
      const body = item.querySelector('.accordion .js-accordion-item__body');
      const arrow = item.querySelector('.accordion .accordion__item-icon');

      if (item.classList.contains('is-open')) {
        body.classList.add('open');
        arrow.classList.add('open-arrow');
        body.style.height = 'auto';
      }

      // Check if wrapper class is already present
      const wrapper = body.querySelector('.accordion-item-wrapper');

      if (!wrapper) {
        // Add wrapper class to accordion item body
        const newWrapper = document.createElement('div');
        newWrapper.classList.add('accordion-item-wrapper');

        // Wrap existing child elements inside the wrapper
        while(body.firstChild) {
          newWrapper.appendChild(body.firstChild);
        }

        // Append the wrapper to the accordion item body
        body.appendChild(newWrapper);
      }

      header.addEventListener('click', () => {

        if (body.classList.contains('open')) {
        // If accordion content is open, close it with a smooth transition
          slideUp(body, arrow);
        } else {
        // If accordion content is closed, open it with a smooth transition
          slideDown(body, arrow);
        }
      });
    });

    function slideDown(element, arrowelement) {
      element.style.height = 'auto';
      const height = element.scrollHeight;
      element.style.height = '0';

      setTimeout(() => {
        element.style.height = `${height  }px`;
        element.classList.add('open');
        arrowelement.classList.add('open-arrow');
      }, 0);
    }

    function slideUp(element, arrowelement) {
      const height = element.scrollHeight;

      element.style.height = `${height  }px`;

      setTimeout(() => {
        element.style.height = '0';
        element.classList.remove('open');
        arrowelement.classList.remove('open-arrow');
      }, 0);

      setTimeout(() => {
        element.style.height = '';
      }, 300);
    }
  }

}



// WEBPACK FOOTER //
// ./src/btu/js/components/Accordion.js